import type { MisconceptionDefinition } from '../types'

export const STU_STUDIEVAARDIGHEDEN_MISCONCEPTIONS: MisconceptionDefinition[] =
  [
    // ───────────────────────────────────────────────────────────
    // STU-NOTITIES — notities maken
    // ───────────────────────────────────────────────────────────
    {
      id: 'stu.notities-letterlijk-overschrijven',
      label: 'Letterlijk overschrijven',
      module: 'Studievaardig',
      description:
        'Leerling probeert alles letterlijk op te schrijven i.p.v. te parafraseren tot kernwoorden.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-esthetiek-boven-functie',
      label: 'Functie en esthetiek verward',
      module: 'Studievaardig',
      description:
        'Leerling besteedt energie aan mooie notities i.p.v. aan informatie-dichtheid en herbruikbaarheid.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-als-sociaal-signaal',
      label: 'Notities als sociaal signaal',
      module: 'Studievaardig',
      description:
        'Leerling maakt notities om aandachtig over te komen i.p.v. om later te kunnen leren.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-hele-zinnen',
      label: 'Hele zinnen in notities',
      module: 'Studievaardig',
      description:
        'Leerling schrijft hele zinnen in notities i.p.v. compacte kernwoorden.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-alleen-titels',
      label: 'Alleen titels genoteerd',
      module: 'Studievaardig',
      description:
        'Leerling denkt dat de hoofdstuk- of paragraaftitel volstaat als notitie.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-een-lange-zin',
      label: 'Eén lange zin',
      module: 'Studievaardig',
      description:
        'Leerling schrijft notities als één lange, ongestructureerde zin.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-pas-voor-toets',
      label: 'Pas voor toets bekijken',
      module: 'Studievaardig',
      description:
        'Leerling wacht tot vlak voor de toets om notities terug te lezen, mist daardoor spaced-repetition effect.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-nooit-teruglezen',
      label: 'Nooit teruglezen',
      module: 'Studievaardig',
      description:
        'Leerling bekijkt notities na het maken nooit meer; notities als wegwerp-handeling.',
      typicalFamilies: ['STU-NOTITIES'],
    },
    {
      id: 'stu.notities-alleen-op-verzoek',
      label: 'Alleen op verzoek leraar',
      module: 'Studievaardig',
      description:
        'Leerling raadpleegt notities alleen als de leraar daarom vraagt, geen eigen leer-strategie.',
      typicalFamilies: ['STU-NOTITIES'],
    },

    // ───────────────────────────────────────────────────────────
    // STU-SAMENVATTEN — samenvattingen
    // ───────────────────────────────────────────────────────────
    {
      id: 'stu.samenvatten-schrijven-voor-lezen',
      label: 'Schrijven zonder lezen',
      module: 'Studievaardig',
      description:
        'Leerling begint te schrijven zonder eerst de tekst overzichtelijk te lezen of te scannen.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-alleen-eerste-alinea',
      label: 'Alleen eerste alinea dekt alles',
      module: 'Studievaardig',
      description:
        'Leerling denkt dat de eerste alinea altijd de hele tekst samenvat.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-woordstudie-ipv-leestechniek',
      label: 'Woordstudie i.p.v. leestechniek',
      module: 'Studievaardig',
      description:
        'Leerling verwart samenvatten met begrippen-opzoeken; behandelt het als woordstudie.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-letterlijk-overschrijven',
      label: 'Samenvatten = overschrijven',
      module: 'Studievaardig',
      description:
        'Leerling verwart samenvatten met letterlijk overschrijven van zinnen.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-titel-als-samenvatting',
      label: 'Titel als samenvatting',
      module: 'Studievaardig',
      description: 'Leerling denkt dat de titel een volledige samenvatting is.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-alles-parafraseren',
      label: 'Alles parafraseren (te lang)',
      module: 'Studievaardig',
      description:
        'Leerling parafraseert elke zin afzonderlijk en eindigt met een samenvatting die langer is dan het origineel.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-hoofdgedachte-weggelaten',
      label: 'Hoofdgedachte weggelaten',
      module: 'Studievaardig',
      description:
        'Leerling laat de hoofdgedachte weg in een samenvatting, focust op secundaire details.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-belangrijke-punten-weggelaten',
      label: 'Belangrijke punten weggelaten',
      module: 'Studievaardig',
      description:
        'Leerling laat belangrijke ondersteunende punten weg en houdt alleen anekdotes over.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-conclusie-weggelaten',
      label: 'Conclusie weggelaten',
      module: 'Studievaardig',
      description:
        'Leerling laat de conclusie/synthese weg uit een samenvatting.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },
    {
      id: 'stu.samenvatten-voorbeeld-als-hoofdzaak',
      label: 'Voorbeeld als hoofdzaak',
      module: 'Studievaardig',
      description:
        'Leerling neemt een specifiek voorbeeld op in de samenvatting in plaats van de hoofdzaak.',
      typicalFamilies: ['STU-SAMENVATTEN'],
    },

    // ───────────────────────────────────────────────────────────
    // STU-PLANNEN — taken plannen
    // ───────────────────────────────────────────────────────────
    {
      id: 'stu.plannen-actie-voor-denken',
      label: 'Actie voor denken',
      module: 'Studievaardig',
      description:
        'Leerling begint direct met de taak zonder eerst een plan te maken.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-materiaal-voor-structuur',
      label: 'Materiaal voor structuur',
      module: 'Studievaardig',
      description:
        'Leerling verzamelt materiaal zonder eerst de structuur van de taak te bepalen.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-review-als-eerste-stap',
      label: 'Review als eerste stap',
      module: 'Studievaardig',
      description:
        'Leerling plaatst controleren/nakijken als eerste stap in het plan.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-uitstelgedrag',
      label: 'Uitstelgedrag',
      module: 'Studievaardig',
      description:
        'Leerling plant taken onrealistisch ver in de toekomst of stelt ze uit.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-tijdsdruk-onderschat',
      label: 'Tijdsdruk onderschat',
      module: 'Studievaardig',
      description: 'Leerling plant te weinig tijd in voor een taak.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-nut-ontkend',
      label: 'Nut van plannen ontkend',
      module: 'Studievaardig',
      description:
        'Leerling ziet het nut van plannen niet in en kiest voor ad-hoc werken.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-deadline-als-optioneel',
      label: 'Deadline als optioneel gezien',
      module: 'Studievaardig',
      description:
        'Leerling behandelt de deadline als een richtlijn in plaats van een harde grens.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-taakverdeling-weggelaten',
      label: 'Taakverdeling weggelaten',
      module: 'Studievaardig',
      description: 'Bij groepswerk vergeet de leerling de taken te verdelen.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-stappen-weggelaten',
      label: 'Essentiële stappen weggelaten',
      module: 'Studievaardig',
      description:
        'Leerling slaat belangrijke tussenstappen over in de planning.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-opgeven-bij-tegenslag',
      label: 'Opgeven bij tegenslag',
      module: 'Studievaardig',
      description:
        'Leerling past het plan niet aan bij tegenslag, maar stopt met de taak.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-onaf-werk-accepteren',
      label: 'Onaf werk accepteren',
      module: 'Studievaardig',
      description:
        'Leerling levert onaf werk in in plaats van de planning aan te passen.',
      typicalFamilies: ['STU-PLANNEN'],
    },
    {
      id: 'stu.plannen-probleem-negeren',
      label: 'Probleem negeren',
      module: 'Studievaardig',
      description:
        'Leerling negeert planningsproblemen in de hoop dat ze vanzelf oplossen.',
      typicalFamilies: ['STU-PLANNEN'],
    },
  ]
